"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfTableCell = void 0;
var table_cell_1 = require("../../../../core/model/tables/main-structures/table-cell");
var rtf_table_cell_properties_1 = require("./properties/rtf-table-cell-properties");
var RtfTableCell = (function () {
    function RtfTableCell(row, _right) {
        if (_right === void 0) { _right = 0; }
        this.startPos = -1;
        this.endPos = -1;
        this.index = -1;
        this.columnSpan = 0;
        this.idForParentCellMap = RtfTableCell.__id++;
        this.row = row;
        this.properties = new rtf_table_cell_properties_1.RtfTableCellProperties();
    }
    Object.defineProperty(RtfTableCell.prototype, "isEmpty", {
        get: function () { return this.startPos == -1 || this.endPos == -1; },
        enumerable: false,
        configurable: true
    });
    RtfTableCell.prototype.createCell = function (row, subDocument) {
        var cell = new table_cell_1.TableCell(row, this.properties.coreProperties);
        cell.startParagraphPosition = subDocument.positionManager.registerPosition(subDocument.getParagraphByPosition(this.startPos).startLogPosition.value);
        cell.endParagrapPosition = subDocument.positionManager.registerPosition(subDocument.getParagraphByPosition(this.endPos).startLogPosition.value);
        cell.columnSpan = this.columnSpan;
        this.properties.apply(cell);
        return cell;
    };
    RtfTableCell.__id = 0;
    return RtfTableCell;
}());
exports.RtfTableCell = RtfTableCell;
